import { ElementsSDK, UiUtilities } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { yiluEnv } from 'utils';
import { getCurrentLanguage } from 'utils/i18n';

import {
  getFareOption,
  getLocationOption,
  reorderLocations,
} from 'modules/eurail/utils/selectUtils';

import { getLocalizedLocationData } from '../../../../utils/locationData';
import { FareType, PassType, getFareOptions } from '../../../../utils/types';
import { EurailSearchFormProps } from '../../../SearchInputPage/components/EurailSipSearchForm/types';
import { useEurailSipSearchForm } from '../../../SearchInputPage/components/EurailSipSearchForm/useEurailSipSearchForm';
import './styles.scss';

export const EurailSrpSearchForm: React.FC<EurailSearchFormProps> = ({ searchInput, onSubmit }) => {
  const { t } = useTranslation();
  const currentLanguage = getCurrentLanguage();
  const { isDesktop } = UiUtilities.useIsDesktop();

  const {
    travellersFields,
    handleOnSubmitButtonClick,
    isFormValid,
    pass,
    to,
    fareClass,
    setTo,
    setFareClass,
  } = useEurailSipSearchForm({ searchInput, onSubmit });

  const isGlobalPass = pass === PassType.GLOBAL;
  const { YILU_EURAIL_COUNTRY_PRIORITY_LIST } = yiluEnv.getVariables();

  const fareOptions = getFareOptions(t);
  const prioritizedCountryList = reorderLocations(
    getLocalizedLocationData(currentLanguage),
    YILU_EURAIL_COUNTRY_PRIORITY_LIST,
  );

  return (
    <div className="eurail-Srp_SearchForm">
      <div className="eurail-Srp_SearchForm__Content">
        <div className="eurail-Srp_SearchForm__Row eurail-SearchForm__Row--inline">
          {!isGlobalPass && (
            <ElementsSDK.InputField.Select
              dataTestId="eurail-pass-location-selector"
              label={isDesktop ? t('eurail.location_label') : undefined}
              placeholder={t('eurail.location_placeholder')}
              defaultOption={getLocationOption(to, currentLanguage)}
              className="eurail-Srp_SearchForm__Field"
              options={prioritizedCountryList}
              onSelect={(value) => setTo(value as string)}
              icon={<ElementsSDK.Icon.PinOutline />}
            />
          )}

          <div className="eurail-Srp_SearchForm__InlineGroup">
            <ElementsSDK.TravellersSelector
              dataTestId="eurail-travellers-selector"
              countLabelSingular={t('Traveller')}
              countLabelPlural={t('Travellers')}
              label={isDesktop ? t('Travellers') : undefined}
              travellers={travellersFields}
              className="eurail-Srp_SearchForm__Field"
            />

            <ElementsSDK.InputField.Select
              dataTestId="eurail-fare-selector"
              label={isDesktop ? t('eurail.class_label') : undefined}
              options={fareOptions}
              defaultOption={getFareOption(fareClass as FareType, fareOptions)}
              className="eurail-Srp_SearchForm__Field"
              onSelect={(value) => setFareClass(value as string)}
            />
          </div>

          <ElementsSDK.Button
            aria-label={t('Search')}
            className="eurail-Srp_SearchForm__Button"
            disabled={!isFormValid}
            onClick={handleOnSubmitButtonClick}
          >
            {t('Search')}
          </ElementsSDK.Button>
        </div>
      </div>
    </div>
  );
};
